export default "__VITE_ASSET__CZlUHS5b__"